// tslint:disable
/**
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
export class EnterpriseCoordinatorSiteServiceModelsSiteUpsearchBaseModel {
    static getAttributeTypeMap() {
        return EnterpriseCoordinatorSiteServiceModelsSiteUpsearchBaseModel.attributeTypeMap;
    }
}
EnterpriseCoordinatorSiteServiceModelsSiteUpsearchBaseModel.discriminator = undefined;
EnterpriseCoordinatorSiteServiceModelsSiteUpsearchBaseModel.additionalProperties = false;
EnterpriseCoordinatorSiteServiceModelsSiteUpsearchBaseModel.attributeTypeMap = [
    {
        "name": "siteId",
        "baseName": "siteId",
        "type": "number"
    },
    {
        "name": "siteRoleType",
        "baseName": "siteRoleType",
        "type": "RoleType"
    },
    {
        "name": "description",
        "baseName": "description",
        "type": "string"
    },
    {
        "name": "nickName",
        "baseName": "nickName",
        "type": "string"
    },
    {
        "name": "businessStartTime",
        "baseName": "businessStartTime",
        "type": "Date"
    },
    {
        "name": "businessEndTime",
        "baseName": "businessEndTime",
        "type": "Date"
    },
    {
        "name": "addresses",
        "baseName": "addresses",
        "type": "Array<EnterpriseCoordinatorSharedAddressUpsearchModel>"
    },
    {
        "name": "contacts",
        "baseName": "contacts",
        "type": "Array<EnterpriseCoordinatorSharedContactUpsearchModel>"
    },
    {
        "name": "emailAddresses",
        "baseName": "emailAddresses",
        "type": "Array<EnterpriseCoordinatorSharedEmailAddressUpsearchModel>"
    },
    {
        "name": "externalIds",
        "baseName": "externalIds",
        "type": "Array<EnterpriseCoordinatorSharedExternalIdUpsearchModel>"
    },
    {
        "name": "phoneNumbers",
        "baseName": "phoneNumbers",
        "type": "Array<EnterpriseCoordinatorSharedPhoneUpsearchModel>"
    },
    {
        "name": "globalIds",
        "baseName": "globalIds",
        "type": "Array<EnterpriseCoordinatorSharedGlobalIdUpsearchModel>"
    },
];
//# sourceMappingURL=enterpriseCoordinatorSiteServiceModelsSiteUpsearchBaseModel.js.map